import {
  Badge,
  BadgeVariant,
} from '../../../components/atoms/badge/badge';
import { TIPO_AVISO_LABEL, TipoAviso } from '../../../types/aviso';

const variantByTipo: Record<TipoAviso, BadgeVariant> = {
  [TipoAviso.GERAL]: 'info',
  [TipoAviso.FINANCEIRO]: 'warning',
};

interface Props {
  tipo: TipoAviso;
}

export const AvisoTipoBadge = ({ tipo }: Props) => (
  <Badge variant={variantByTipo[tipo] ?? 'neutral'}>
    {TIPO_AVISO_LABEL[tipo] ?? tipo}
  </Badge>
);
